import { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1, graphicDataColor5 } from "../../../../../config/constants";
// Components
import GraphicContainer from "../../../../GraphicContainer";
import Graphic from "../../../../graphic";

const LinePlot = forwardRef(({ evaluationDates, evaluations, title, min = 0, max = 10, hasTwoLines, showLegend }, ref) => {
  const [positions, setPositions] = useState([]);
  const [PREValues, setPREValues] = useState([]);
  const [POSTValues, setPOSTValues] = useState([]);
  const [t] = useTranslation("global");

  // Set positions and values
  useEffect(() => {
    evaluationDates.forEach((evaluationDate, i) => {
      setPositions((prevPositions) => [...prevPositions, i + 1]);
      const evaluation = evaluations.filter((evaluation) => evaluation.EVALUATION_DATE.substring(0, 10) === evaluationDate);
      setPREValues((prevPositions) => [...prevPositions, evaluation[0].hasOwnProperty(title) ? evaluation[0][title] : NaN]);
      if (hasTwoLines) {
        setPOSTValues((prevPositions) => [
          ...prevPositions,
          evaluation.length < 2 ? NaN : evaluation[1].hasOwnProperty(title) ? evaluation[1][title] : NaN,
        ]);
      }
    });

    return () => {
      setPositions([]);
      setPREValues([]);
      setPOSTValues([]);
    };
  }, [evaluationDates, evaluations, title, hasTwoLines]);

  const data = {
    labels: positions,
    datasets: hasTwoLines
      ? [
          {
            label: `${t("evaluation")} PRE`,
            data: PREValues,
            backgroundColor: [graphicDataColor1],
            borderColor: [graphicDataColor1],
          },
          {
            label: `${t("evaluation")} POST`,
            data: POSTValues,
            backgroundColor: [graphicDataColor5],
            borderColor: [graphicDataColor5],
          },
        ]
      : [
          {
            data: PREValues,
            backgroundColor: [graphicDataColor1],
            borderColor: [graphicDataColor1],
          },
        ],
  };

  return (
    <GraphicContainer ref={ref}>
      <Graphic
        Title={t(title)}
        Type={Line}
        data={data}
        axisY={t(title)}
        axisX={t("sessions")}
        min={min}
        max={max}
        showLegend={showLegend}
      />
    </GraphicContainer>
  );
});

export default LinePlot;
